"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "default", {
  enumerable: true,
  get: function get() {
    return _Div100vh.default;
  }
});

require("./polyfill");

var _Div100vh = _interopRequireDefault(require("./Div100vh"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/react-div-100vh/lib/index.js
// module id = 348
// module chunks = 0